import { render, staticRenderFns } from "./VistaPreviaAcuerdo.vue?vue&type=template&id=b1624f22"
import script from "./VistaPreviaAcuerdo.vue?vue&type=script&lang=js"
export * from "./VistaPreviaAcuerdo.vue?vue&type=script&lang=js"
import style0 from "./VistaPreviaAcuerdo.vue?vue&type=style&index=0&id=b1624f22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VIcon,VSelect,VTextarea})
